import React, { useState } from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEllipsisV,
  faUsers,
  faInfoCircle,
  faTrash
} from '@fortawesome/free-solid-svg-icons';
import UserAvatar from './UserAvatar';
import './ThreadHeader.css';

function ThreadHeader({ thread }) {
  const [showParticipants, setShowParticipants] = useState(false);

  const isGroupChat = thread.threadType === 'group';
  const displayName = isGroupChat
    ? thread.participantDetails.map(p => p.displayName).join(', ')
    : thread.participantDetails[0]?.displayName || 'Unknown User';

  return (
    <div className="thread-header">
      <div className="d-flex align-items-center flex-grow-1">
        <div className="thread-avatar me-3">
          {isGroupChat ? (
            <div className="group-avatar-header">
              <FontAwesomeIcon icon={faUsers} />
            </div>
          ) : (
            <UserAvatar
              photoUrl={thread.participantDetails[0]?.photoUrl}
              displayName={thread.participantDetails[0]?.displayName}
              size="md"
            />
          )}
        </div>

        <div className="thread-info">
          <h6 className="mb-0">{displayName}</h6>
          {isGroupChat && (
            <small className="text-muted">
              {thread.participantDetails.length} participants
            </small>
          )}
        </div>
      </div>

      <div className="thread-actions">
        <Button
          variant="link"
          className="text-muted"
          onClick={() => setShowParticipants(!showParticipants)}
        >
          <FontAwesomeIcon icon={faInfoCircle} />
        </Button>

        <Dropdown align="end">
          <Dropdown.Toggle variant="link" className="text-muted no-caret">
            <FontAwesomeIcon icon={faEllipsisV} />
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item>
              <FontAwesomeIcon icon={faUsers} className="me-2" />
              View Participants
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item className="text-danger">
              <FontAwesomeIcon icon={faTrash} className="me-2" />
              Delete Conversation
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
}

export default ThreadHeader;
